import React from 'react';
import { Button } from 'src/components';
import { $colors } from 'src/theme/colors';
type Props = {
  testID?: string;
  nextLabel: string;
  previewLabel: string;
  onNext?: () => void;
  onPreview: () => void;
  isNotSubmit?: boolean;
};

export const FooterActions: React.FC<Props> = ({
  isNotSubmit,
  onPreview,
  onNext,
  previewLabel,
  nextLabel,
  testID = 'FooterActions',
}) => {
  return (
    <div className="bottom-6 w-full md:static md:mt-10 md:w-auto py-4 mt-10">
      <div data-testid={testID} className="flex flex-row justify-between m-auto px-2 left-0">
        <Button
          extraClasses="px-8 bg-primary"
          label={previewLabel}
          theme="primary"
          style={{ color: $colors.primary }}
          onClick={onPreview}
        />
        <Button label={nextLabel} extraClasses="px-8" onClick={onNext} type={!isNotSubmit ? 'submit' : undefined} />
      </div>
    </div>
  );
};
